'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var react = require('react');
var Grid = require('../Grid.js');
var grid_module = require('../grid.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var GridItem = function (_a) {
    var _b = _a.childClassName, childClassName = _b === void 0 ? '' : _b, _c = _a.firstChildClassName, firstChildClassName = _c === void 0 ? '' : _c, _d = _a.lastChildClassName, lastChildClassName = _d === void 0 ? '' : _d, children = _a.children;
    var col = react.useContext(Grid.GridCtx);
    var childrenLength = react.Children.toArray(children).length;
    var mappedChildren = react.Children.map(children, function (child, indx) {
        var _a;
        if (!react.isValidElement(child)) {
            return null;
        }
        var row = indx + 1;
        var isFirst = indx === 0;
        var isLast = indx === childrenLength - 1;
        var gridItemClassName = cx__default.default(grid_module.default['grid__cell'], grid_module.default["grid__cell--row-".concat(row)], grid_module.default["grid__cell--col-".concat(col)], childClassName, (_a = {},
            _a[firstChildClassName] = isFirst,
            _a[lastChildClassName] = isLast,
            _a));
        return (jsxRuntime.jsx("div", tslib.__assign({ "data-testid": "grid-cell-test", className: gridItemClassName }, { children: child })));
    });
    return jsxRuntime.jsx(jsxRuntime.Fragment, { children: mappedChildren });
};
var GridItem$1 = GridItem;

exports.default = GridItem$1;
//# sourceMappingURL=GridItem.js.map
